import { AxiosResponse } from 'axios';
import { Request } from '../../../api';
import { ResetPasswordDto } from '../auth.types';

export function resetPassword(params: ResetPasswordDto): Promise<AxiosResponse<void>> {
    return Request.post('authentication/password/reset', params);
}
